import React, { useState, useEffect } from 'react';
import axios from 'axios';
import EventForm from './EventForm';
import Timeline from './Timeline';
import Login from './Login';
import Register from './Register';
import './App.css';

const API_URL = process.env.REACT_APP_API_URL;

function App() {
  const [events, setEvents] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showLogin, setShowLogin] = useState(true);  // State to toggle between login and register

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setIsAuthenticated(true);
      fetchEvents(token);
    }
  }, []);

  const fetchEvents = async (token) => {
    try {
      const { data } = await axios.get(`${API_URL}/events`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const sortedData = data.sort((a, b) => new Date(b.date) - new Date(a.date));
      setEvents(sortedData);
    } catch (error) {
      console.error('Error fetching events:', error);
    }
  };

  const saveEvent = async (event) => {
    try {
      const token = localStorage.getItem('token');
      const { data } = await axios.post(`${API_URL}/events`, event, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setEvents(prevEvents => [data, ...prevEvents]);
      setShowForm(false);
    } catch (error) {
      console.error('Error saving event:', error);
    }
  };

  const deleteEvent = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/events/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setEvents(prevEvents => prevEvents.filter(event => event._id !== id));
    } catch (error) {
      console.error('Error deleting event:', error);
    }
  };

  const editEvent = async (id, updatedEvent) => {
    try {
      const token = localStorage.getItem('token');
      const { data } = await axios.put(`${API_URL}/events/${id}`, updatedEvent, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setEvents(prevEvents => {
        return prevEvents.map(event => (event._id === id ? { ...event, ...data } : event));
      });
    } catch (error) {
      console.error('Error editing event:', error);
    }
  };

  const toggleForm = () => {
    setShowForm(!showForm);
  };

  const handleLogin = (token) => {
    localStorage.setItem('token', token);
    setIsAuthenticated(true);
    fetchEvents(token);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    setEvents([]);
  };

  const toggleLoginRegister = () => {
    setShowLogin(!showLogin);
  };

  if (!isAuthenticated) {
    return (
      <div className="App">
        {showLogin ? (
          <Login onLogin={handleLogin} />
        ) : (
          <Register onRegister={handleLogin} />
        )}
        <button className="toggle-button" onClick={toggleLoginRegister}>
          {showLogin ? 'Go to Register' : 'Go to Login'}
        </button>
      </div>
    );
  }

  return (
    <div className="App">
      <h1 className="app-title"><span className="app-title-j">J</span>ourney</h1>
      <button onClick={toggleForm} className="add-event-button">
        {showForm ? 'Cancel' : '+ Add Event'}
      </button>
    {showForm && <EventForm saveEvent={saveEvent} />}
      <Timeline events={events} deleteEvent={deleteEvent} editEvent={editEvent} />
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
}

export default App;
